module.exports = __webpack_public_path__ + "img/creditos-img.5f8a2d3f.svg";